import React from 'react';
import Hero from './../components/Hero';
import ContactForm from './../components/ContactForm';
import { Grid } from "react-bootstrap";

class Contact extends React.Component{
    render(){
        return(
            <Grid fluid>
                <Hero title={"Contactenos"} />
                <ContactForm />
            </Grid>
        )
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/containers/Contact.js